import React, { useState, useEffect } from 'react';
import { Box, Button } from '@mui/material';
import { FieldArray, Form, Formik } from 'formik';
import { useSnackbar } from 'notistack';
import * as yup from 'yup';
import _ from 'lodash';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import * as fileApi from '../../../lib/api/file';
import { listSalesFiles } from '../../../modules/projectModule/purchaseOrderFiles';
import SalesMultiFileForm from '../../../components/projectmng/purchaseorder/SalesMultiFileForm';

const validationSchema = yup.object().shape({
  files: yup.array().of(
    yup.object().shape({
      fileAttrVal5: yup
        .date()
        .required('받은일자를 입력하세요')
        .nullable()
        .default(undefined),
      fileDesc: yup.string().nullable('비고를 입력하세요'),
      file: yup.mixed().nullable().required('파일을 선택하세요'),
    }),
  ),
});

const SalesFileFormContainer = () => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { project } = useSelector(({ projectModule }) => ({
    project: projectModule.project.project,
  }));

  const onSave = async (value) => {
    // console.log(selectedPartner, 'selectedPartner');
    const fileAttrVal5 = value?.fileAttrVal5
      ? dayjs(value?.fileAttrVal5).format('YYYY-MM-DD')
      : dayjs(new Date()).format('YYYY-MM-DD');

    let formData = new FormData();
    formData.append('fileDt', value.file);
    formData.append('fileTyp', 'PURCHASE_ORDER');
    formData.append('fileAttrVal1', project.prjUuid);
    formData.append('fileAttrVal2', '받은발주서');
    formData.append('fileAttrVal3', project?.vendorCmp); //매출처
    formData.append('fileAttrVal4', project?.totalSales); //매출금액
    formData.append('fileAttrVal5', fileAttrVal5);
    formData.append('fileDesc', value.fileDesc);
    //console.log(formData, 'formData');

    try {
      const response = await fileApi.addFiles(formData);
      if (response.data) {
        dispatch(listSalesFiles({ prjUuid: project.prjUuid }));
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  return (
    <Box sx={{ my: 1 }}>
      <Formik
        initialValues={{
          files: [
            {
              fileAttrVal5: new Date(),
              fileDesc: '',
              file: null,
            },
          ],
        }}
        validationSchema={validationSchema}
        onSubmit={async (values, { resetForm }) => {
          // console.log("onSubmit", JSON.stringify(values, null, 2));
          if (values.files.length > 0 && values.files[0].file) {
            values.files.forEach((value) => {
              onSave(value);
            });
            resetForm();
          }
        }}
      >
        {({
          isSubmitting,
          values,
          touched,
          errors,
          handleChange,
          handleBlur,
          isValid,
          arrayHelpers,
        }) => (
          <Form noValidate autoComplete="off">
            <FieldArray
              name="files"
              render={(arrayHelpers) => (
                <Box>
                  <Box>
                    {values.files.map((f, index) => {
                      return (
                        <SalesMultiFileForm
                          key={index}
                          file={f}
                          index={index}
                          touched={touched}
                          errors={errors}
                          handleChange={handleChange}
                          handleBlur={handleBlur}
                          handleRemove={() => arrayHelpers.remove(index)}
                          project={project}
                        />
                      );
                    })}
                  </Box>
                  <Box
                    sx={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      alignItems: 'center',
                      my: 2,
                    }}
                  >
                    <Button
                      sx={{ mx: 2 }}
                      color="secondary"
                      variant="outlined"
                      onClick={() =>
                        arrayHelpers.push({
                          sellPartnerUuid: '',
                          fileDesc: '',
                          file: null,
                        })
                      }
                    >
                      파일 추가
                    </Button>
                    <Button
                      type="submit"
                      color="primary"
                      variant="contained"
                      disabled={
                        !isValid || values.files.length === 0 || isSubmitting
                      }
                    >
                      저장
                    </Button>
                  </Box>
                </Box>
              )}
            ></FieldArray>
          </Form>
        )}
      </Formik>
    </Box>
  );
};

export default SalesFileFormContainer;
